import { Heading, Stack, SystemStyleObject } from '@telescope/cassini-ui';
import { TimeStat, TimeStatLabel, TimeStatValue } from 'components';
import { format } from 'date-fns';

type TimeAndDateData = {
  settings: {
    timeAndDateTarget: number;
  };
  content: {
    description?: string;
    hourLabel?: string;
  };
  styles?: {
    description?: SystemStyleObject;
    container?: SystemStyleObject;
    timeStat?: {
      root?: SystemStyleObject;
      value?: SystemStyleObject;
      label?: SystemStyleObject;
    };
  };
};

export const TimeAndDate = ({ content, settings, styles = {} }: TimeAndDateData) => {
  const timeAndDate = new Date(settings.timeAndDateTarget);

  return (
    <>
      <Heading as="h2" size="sm" mb={4} sx={styles.description}>
        {content.description}
      </Heading>

      <Stack direction={'row'} alignSelf="stretch" justifyContent={'space-between'} mb={9} sx={styles.container}>
        <TimeStat variant="relaxed" sx={styles.timeStat?.root}>
          <TimeStatValue whiteSpace="nowrap" sx={styles.timeStat?.value}>
            {format(timeAndDate, 'hh:mm aaa')}
          </TimeStatValue>
          <TimeStatLabel sx={styles.timeStat?.label}> {content.hourLabel} </TimeStatLabel>
        </TimeStat>
        <TimeStat variant="relaxed" sx={styles.timeStat?.root}>
          <TimeStatValue sx={styles.timeStat?.value}> {format(timeAndDate, 'dd')} </TimeStatValue>
          <TimeStatLabel sx={styles.timeStat?.label}> {format(timeAndDate, 'MMMM')} </TimeStatLabel>
        </TimeStat>
      </Stack>
    </>
  );
};
